import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { InputText } from "primereact/inputtext";
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import moment from "moment";
import "moment/locale/es";

const dateFormats = [
    "DD/MM/YYYY",
    "MM/DD/YYYY",
    "YYYY/MM/DD",
    "YYYY-MM-DD",
    "DD-MM-YYYY",
    "MM-DD-YYYY",
    "DD MMM YYYY",
    "MMM DD, YYYY",
    "MMMM DD, YYYY",
    "YYYY MMM DD",
    ];

const ServiciosDataTable = ({
    servicios,
    loading,
    cotizacion,
    desde,
    hasta,
    idCotizacion,
    idCliente,
    flattenedDataArriendo,
    setLoading,
    setDesde,
    setHasta,
    handleTablaChange,
    postUpdateDataCotizacion,
    updateCotizacion,
    handleNewTramoServicio,
    handleBorrarLinea,
    cobroOptionsServicios,
    monedaOptions,
    handleTramoConfirmationServicio,
    showTramoModalServicio,
    setShowTramoModalServicio,
    nombreCuadro,
    setNombreCuadro,
    tramos,
    tramoCounter,
    selectFechaTramo,
    subtotalServicios,
    }) => {
    return (
        <>
        <div
            style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "10px",
            }}
        >
            <div
            style={{
                width: "20px",
                height: "10px",
                marginRight: "5px",
                backgroundColor: "yellow",
                border: "1px solid #ccc",
            }}
            ></div>
            <div>: Tarifa Variable</div>
        </div>
        {/* BODY */}
        <DataTable
            value={servicios}
            className="p-datatable-gridlines"
            showGridlines
            rows={10}
            header={`Servicios`}
            emptyMessage="No seleccionó servicios"
            loading={loading}
        >
            {/* columna activo */}
            <Column
            field="es_union"
            header="Estado"
            body={(rowData) => (
                <>
                <div>
                    <Button
                        icon="pi pi-check"
                        className="p-button-rounded p-button-success p-button"
                        outlined
                        tooltip="Servicio Disponible"
                        tooltipOptions={{ position: "top" }}
                    />
                </div>
                </>
            )}
            />

            <Column
            field="descripcion"
            header="Nombre"
            body={(rowData) => (
                <div
                style={{
                    backgroundColor: rowData.remarcador ? "yellow" : "inherit",
                }}
                >
                {rowData.descripcion}
                </div>
            )}
            />

            <Column
            field="tramo"
            header="Tramo"
            body={(rowData) => (rowData.tramo === "null" ? "" : rowData.tramo)}
            />

            <Column
            header="Fecha Desde"
            body={(rowData) => {
                return (
                <Calendar
                    style={{ width: "100%", minWidth: "100px" }}
                    value={moment(rowData.desde, "YYYY-MM-DD", true).toDate()}
                    dateFormat="dd/mm/yy"
                    disabled
                    minDate={moment(desde, "YYYY-MM-DD", true).toDate()}
                    maxDate={moment(hasta, "YYYY-MM-DD", true).toDate()}
                    onChange={(e) => {
                    const newDate = moment(e.value, "YYYY-MM-DD", true);

                    if (newDate.isValid()) {
                        const isOutsideRange =
                        newDate.isBefore(moment(desde, "YYYY-MM-DD", true)) ||
                        newDate.isAfter(moment(hasta, "YYYY-MM-DD", true));

                        if (isOutsideRange) {
                        async function handleUpdateAndReload() {
                            setLoading(true);

                            const desdeTransformed = newDate.format("YYYY-MM-DD");
                            const hastaTransformed = moment(
                            rowData.hasta,
                            "YYYY-MM-DD",
                            true
                            ).format("YYYY-MM-DD");

                            await handleTablaChange(
                            rowData,
                            desdeTransformed,
                            "servicios",
                            "desde"
                            );

                            await postUpdateDataCotizacion(
                            { ...rowData, desde: desdeTransformed },
                            false
                            );

                            await updateCotizacion(
                            idCotizacion,
                            idCliente,
                            cotizacion?.estado?.id_estado,
                            sessionStorage.getItem("usuario_id"),
                            desdeTransformed,
                            hastaTransformed,
                            cotizacion?.aviso
                            );

                            const baseUrl = window.location.href.split("/#/")[0];
                            const urlAVolver = `/revisarCotizacion?idCliente=${idCliente}&idCotizacion=${idCotizacion}&desde=${desdeTransformed}&hasta=${hastaTransformed}`;
                            const fullUrl = `${baseUrl}/#${urlAVolver}`;
                            setDesde(desdeTransformed);
                            setHasta(hastaTransformed);
                            window.location.href = fullUrl;
                            setLoading(false);
                        }

                        handleUpdateAndReload();
                        } else {
                        async function handleReload() {
                            setLoading(true);

                            const desdeTransformed = newDate.format("YYYY-MM-DD");

                            await handleTablaChange(
                            rowData,
                            desdeTransformed,
                            "servicios",
                            "desde"
                            );

                            await postUpdateDataCotizacion(
                            { ...rowData, desde: desdeTransformed },
                            false
                            );

                            const updatedServicios = servicios.map((item) =>
                            item.id === rowData.id
                                ? { ...item, desde: desdeTransformed }
                                : item
                            );

                            const allDesdeDates = [
                            ...flattenedDataArriendo.map((item) =>
                                moment(item.desde, "YYYY-MM-DD", true)
                            ),
                            ...updatedServicios.map((item) =>
                                moment(item.desde, "YYYY-MM-DD", true)
                            ),
                            ];

                            const currentMinDesde = moment.min(allDesdeDates);

                            let currentDesde;

                            if (desde) {
                            currentDesde = moment(desde, "YYYY-MM-DD", true);

                            if (!currentDesde.isValid()) {
                                console.warn(
                                "Attempting to parse currentHasta with alternate format (DD/MM/YYYY)"
                                );
                                currentDesde = moment(desde, "DD/MM/YYYY", true);
                            }
                            } else {
                            console.error("cotizacion.hasta is undefined or null.");
                            }

                            if (
                            currentDesde &&
                            currentMinDesde.isValid() &&
                            currentMinDesde.isValid()
                            ) {
                            if (!currentMinDesde.isSame(currentDesde, "day")) {
                                const hastaTransformed = moment(
                                rowData.hasta,
                                "YYYY-MM-DD",
                                true
                                ).format("YYYY-MM-DD");

                                await updateCotizacion(
                                idCotizacion,
                                idCliente,
                                cotizacion?.estado?.id_estado,
                                sessionStorage.getItem("usuario_id"),
                                currentMinDesde.format("YYYY-MM-DD"),
                                hastaTransformed,
                                cotizacion?.aviso
                                );
                                const baseUrl =
                                window.location.href.split("/#/")[0];

                                const urlAVolver = `/revisarCotizacion?idCliente=${idCliente}&idCotizacion=${idCotizacion}&desde=${currentMinDesde.format(
                                "YYYY-MM-DD"
                                )}&hasta=${hastaTransformed}`;
                                const fullUrl = `${baseUrl}/#${urlAVolver}`;
                                setDesde(currentMinDesde.format("YYYY-MM-DD"));
                                setHasta(hastaTransformed);
                                window.location.href = fullUrl;
                                setLoading(false);
                            } else {
                                console.log("Dates are the same; no update needed.");
                            }
                            }

                            setLoading(false);
                        }

                        handleReload();
                        }
                    }
                    }}
                />
                );
            }}
            />

            <Column
            header="Fecha Hasta"
            body={(rowData) => {
                return (
                <Calendar
                    style={{ width: "100%", minWidth: "100px" }}
                    value={moment(rowData.hasta, "YYYY-MM-DD", true).toDate()}
                    dateFormat="dd/mm/yy"
                    disabled={
                    (rowData.tramo && rowData.tramo.includes("Tramo")) ||
                    cotizacion?.estado.estado === "ASIGNACIÓN" ||
                    cotizacion?.estado.estado === "ANULADA" ||
                    rowData.descripcion.includes("Gasto") ||
                    cotizacion?.estado.estado === "RECHAZADA"
                    }
                    maxDate={moment(hasta, "YYYY-MM-DD", true).toDate()}
                    minDate={moment(desde, "YYYY-MM-DD", true)
                    .add(1, "day")
                    .toDate()}
                    onChange={(e) => {
                    const newDate = moment(e.value, "YYYY-MM-DD", true);

                    if (newDate.isValid()) {
                        const isOutsideRange =
                        newDate.isBefore(moment(desde, "YYYY-MM-DD", true)) ||
                        newDate.isAfter(moment(hasta, "YYYY-MM-DD", true));

                        if (isOutsideRange) {
                        async function handleUpdateAndReload() {
                            setLoading(true);

                            const desdeTransformed = moment(
                            rowData.desde,
                            "YYYY-MM-DD",
                            true
                            ).format("YYYY-MM-DD");
                            const hastaTransformed = newDate.format("YYYY-MM-DD");

                            await handleTablaChange(
                            rowData,
                            hastaTransformed,
                            "servicios",
                            "hasta"
                            );

                            await postUpdateDataCotizacion(
                            { ...rowData, hasta: hastaTransformed },
                            false
                            );

                            await updateCotizacion(
                            idCotizacion,
                            idCliente,
                            cotizacion?.estado?.id_estado,
                            sessionStorage.getItem("usuario_id"),
                            desdeTransformed,
                            hastaTransformed,
                            cotizacion?.aviso
                            );
                            const baseUrl = window.location.href.split("/#/")[0];

                            const urlAVolver = `/revisarCotizacion?idCliente=${idCliente}&idCotizacion=${idCotizacion}&desde=${desdeTransformed}&hasta=${hastaTransformed}`;
                            const fullUrl = `${baseUrl}/#${urlAVolver}`;
                            setDesde(desdeTransformed);
                            setHasta(hastaTransformed);
                            window.location.href = fullUrl;
                            setLoading(false);
                        }

                        handleUpdateAndReload();
                        } else {
                        async function handleReload() {
                            setLoading(true);

                            const hastaTransformed = newDate.format("YYYY-MM-DD");

                            await handleTablaChange(
                            rowData,
                            hastaTransformed,
                            "servicios",
                            "hasta"
                            );

                            await postUpdateDataCotizacion(
                            { ...rowData, hasta: hastaTransformed },
                            false
                            );

                            const updatedServicios = servicios.map((item) =>
                            item.id === rowData.id
                                ? { ...item, hasta: hastaTransformed }
                                : item
                            );

                            const allHastaDates = [
                            ...flattenedDataArriendo.map((item) =>
                                moment(item.hasta, "YYYY-MM-DD", true)
                            ),
                            ...updatedServicios.map((item) =>
                                moment(item.hasta, "YYYY-MM-DD", true)
                            ),
                            ];

                            const currentMaxHasta = moment.max(allHastaDates);

                            let currentHasta;

                            if (hasta) {
                            currentHasta = moment(hasta, "YYYY-MM-DD", true);

                            if (!currentHasta.isValid()) {
                                console.warn(
                                "Attempting to parse currentHasta with alternate format (DD/MM/YYYY)"
                                );
                                currentHasta = moment(hasta, "DD/MM/YYYY", true);
                            }
                            } else {
                            console.error("cotizacion.hasta is undefined or null.");
                            }

                            if (
                            currentHasta &&
                            currentMaxHasta.isValid() &&
                            currentHasta.isValid()
                            ) {
                            console.log(
                                "currentHasta",
                                currentHasta.format("YYYY-MM-DD")
                            );
                            console.log(
                                "currentMaxHasta",
                                currentMaxHasta.format("YYYY-MM-DD")
                            );

                            if (!currentMaxHasta.isSame(currentHasta, "day")) {
                                console.log(
                                "Dates are different. Proceeding with update..."
                                );

                                const desdeTransformed = moment(
                                rowData.desde,
                                "YYYY-MM-DD",
                                true
                                ).format("YYYY-MM-DD");

                                await updateCotizacion(
                                idCotizacion,
                                idCliente,
                                cotizacion?.estado?.id_estado,
                                sessionStorage.getItem("usuario_id"),
                                desdeTransformed,
                                currentMaxHasta.format("YYYY-MM-DD"),
                                cotizacion?.aviso
                                );

                                const baseUrl =
                                window.location.href.split("/#/")[0];
                                const urlAVolver = `/revisarCotizacion?idCliente=${idCliente}&idCotizacion=${idCotizacion}&desde=${desdeTransformed}&hasta=${currentMaxHasta.format(
                                "YYYY-MM-DD"
                                )}`;
                                const fullUrl = `${baseUrl}/#${urlAVolver}`;
                                setDesde(desdeTransformed);
                                setHasta(currentMaxHasta.format("YYYY-MM-DD"));
                                console.log("Navigating to:", fullUrl);
                                window.location.href = fullUrl;
                                setLoading(false);
                            } else {
                                console.log("Dates are the same; no update needed.");
                            }
                            } else {
                            console.error("Invalid dates:", {
                                currentMaxHasta: currentMaxHasta.toString(),
                                currentHasta: currentHasta
                                ? currentHasta.toString()
                                : "Invalid date",
                                rawHasta: cotizacion.hasta,
                            });
                            }

                            setLoading(false);
                        }

                        handleReload();
                        }
                    }
                    }}
                />
                );
            }}
            />

            <Column
                header="Documento Cobro"
                body={(rowData) => (
                    <Dropdown
                    value={rowData.cobro}
                    options={cobroOptionsServicios}
                    onChange={(e) =>
                        handleTablaChange(rowData, e.value, "servicios", "cobro")
                    }
                    optionLabel="label"
                    optionValue="value"
                    placeholder={rowData.cobro}
                    disabled={
                        rowData.descripcion.includes("Agua") ||
                        rowData.descripcion.includes("Electricidad") ||
                        cotizacion?.estado.estado === "ASIGNACIÓN" ||
                        cotizacion?.estado.estado === "ANULADA" ||
                        cotizacion?.estado.estado === "RECHAZADA"
                        }
                    />
                )}
            />

            <Column header="Medida" field="unidad" />

            <Column
                header="Tarifa Base"
                field="tarifa_base"
                maxFractionDigits={4}
                mode="decimal"
                style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
                body={(rowData) => (
                    <span>
                    {rowData.tarifa_base.toFixed(2).toString().replace(".", ",")} UF
                    </span>
                )}
            />

            <Column
                header="Moneda"
                body={(rowData) => {
                    const filteredOptions = monedaOptions.filter(
                    (item) => item.idEmpresa === rowData.id_empresa
                    );

                    return (
                    <Dropdown
                        value={rowData.moneda}
                        options={filteredOptions}
                        onChange={(e) => {
                            handleTablaChange(rowData, e.value, "servicios", "moneda");
                        }}
                        optionLabel="codigo"
                        optionValue="codigo"
                        placeholder={rowData.moneda}
                        disabled={
                        (rowData.moneda === "CLP" &&
                            (rowData.descripcion.includes("Agua") ||
                            rowData.descripcion.includes("Electricidad"))) ||
                        cotizacion?.estado.estado === "ASIGNACIÓN" ||
                        cotizacion?.estado.estado === "ANULADA" ||
                        cotizacion?.estado.estado === "RECHAZADA"
                        }
                    />
                    );
                }}
            />

            <Column
                header="Tarifa Cliente"
                body={(rowData) => (
                    <React.Fragment>
                    <InputNumber
                        value={rowData.tarifa_cliente}
                        onChange={(e) => {
                            handleTablaChange(
                            rowData,
                            e.value,
                            "servicios",
                            "tarifa_cliente"
                            );
                        }}
                        locale="es-CL"
                        mode="decimal"
                        maxFractionDigits={5}
                        disabled={
                        cotizacion?.estado.estado === "ASIGNACIÓN" ||
                        cotizacion?.estado.estado === "ANULADA" ||
                        rowData.descripcion.includes("Agua") ||
                        rowData.descripcion.includes("Electricidad") ||
                        cotizacion?.estado.estado === "RECHAZADA"
                        }
                    />
                    </React.Fragment>
                )}
            />

            <Column
                header="Descuento Tarifa %"
                field="descuento"
                body={(rowData) => (
                    <>
                    {rowData.moneda === "UF" ? (
                        <>
                        <InputNumber
                            value={isFinite(rowData.descuento) ? rowData.descuento : 0}
                            onChange={(e) => {
                                handleTablaChange(
                                rowData,
                                e.value,
                                "servicios",
                                "descuento"
                                );
                            }}
                            locale="es-CL"
                            mode="decimal"
                            maxFractionDigits={4}
                            disabled={
                            rowData.tarifa_base === 0 ||
                            cotizacion?.estado.estado === "ASIGNACIÓN" ||
                            cotizacion?.estado.estado === "ANULADA" ||
                            rowData.descripcion.includes("Agua") ||
                            rowData.descripcion.includes("Electricidad") ||
                            cotizacion?.estado.estado === "RECHAZADA"
                            }
                        />
                        </>
                    ) : (
                        <>
                        <InputNumber
                            value={0}
                            onChange={(e) => {
                                handleTablaChange(
                                rowData,
                                e.value,
                                "servicios",
                                "descuento"
                                );
                            }}
                            locale="es-CL"
                            mode="decimal"
                            maxFractionDigits={4}
                            disabled
                        />
                        </>
                    )}
                    </>
                )}
            />

            <Column
                header="Tarifa Diaria"
                style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
                body={(rowData) =>
                    rowData.tarifa_diaria === "Tarifa Variable"
                    ? rowData.tarifa_diaria
                    : rowData.tarifa_diaria
                    ? parseFloat(rowData.tarifa_diaria).toLocaleString("es-CL", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                        }) + " UF"
                    : ""
                }
            />

            <Column
                header="Tarifa Mensual"
                style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                }}
                body={(rowData) =>
                    rowData.tarifa_mensual === "Tarifa Variable"
                    ? rowData.tarifa_mensual
                    : rowData.tarifa_mensual
                    ? parseFloat(rowData.tarifa_mensual).toLocaleString("es-CL", {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                        }) + " UF"
                    : ""
                }
            />

            {/* SECCION DE BOTONES */}
            {cotizacion?.estado.estado !== "ASIGNACIÓN" && (
            <Column
                header="Acción"
                style={{ minWidth: "120px" }}
                body={(rowData) => (
                <>
                    <Button
                    icon="pi pi-plus"
                    className="p-button-rounded p-button-success p-button mr-2"
                    label=""
                    onClick={() => handleNewTramoServicio(rowData)}
                    disabled={
                        (rowData.tramo && rowData.tramo.includes("Tramo")) ||
                        rowData.descripcion.includes("Agua") ||
                        rowData.descripcion.includes("Electricidad") ||
                        cotizacion?.estado.estado === "ANULADA" ||
                        cotizacion?.estado.estado === "ASIGNACIÓN" ||
                        cotizacion?.estado.estado === "RECHAZADA"
                    }
                    outlined
                    ></Button>
                    <Button
                    icon="pi pi-trash"
                    className="p-button-rounded p-button-danger p-button ml-2"
                    label=""
                    onClick={() => handleBorrarLinea(rowData, "servicios")}
                    outlined
                    disabled={
                        loading ||
                        cotizacion?.estado.estado === "ANULADA" ||
                        cotizacion?.estado.estado === "ASIGNACIÓN" ||
                        cotizacion?.estado.estado === "RECHAZADA"
                    }
                    ></Button>
                    <Dialog
                    visible={showTramoModalServicio}
                    onHide={() => {
                        setShowTramoModalServicio(false);
                    }}
                    style={{ width: "1200px" }}
                    modal
                    dismissableMask={false}
                    >
                    <div className="flex align-items-center justify-content-center">
                        <div className="grid">
                        <div className="col-12">
                            <h5>
                            Seleccione tramos a generar para {nombreCuadro}
                            </h5>
                            <div>
                            {tramos.map((tramo, index) => (
                                <div
                                key={index}
                                className="p-fluid formgrid grid"
                                >
                                <div className="field col-12 md:col-4">
                                    <label htmlFor={`descripcionSubP_${index}`}>
                                    Tramo {index + 1}
                                    </label>
                                    <InputText
                                    id={`descripcionSubP_${index}`}
                                    value={tramo.descripcion}
                                    disabled
                                    onChange={(e) => setNombreCuadro(e.value)}
                                    />
                                </div>
                                <div className="field col-12 md:col-4">
                                    <label htmlFor={`desde_${index}`}>Desde</label>
                                    <Calendar
                                    id={`desde_${index}`}
                                    showIcon
                                    value={moment(
                                        tramo.desde,
                                        dateFormats,
                                        true
                                    ).toDate()}
                                    onChange={(e) => {}}
                                    minDate={
                                        moment(
                                        tramo.desde,
                                        dateFormats,
                                        true
                                        ).isValid()
                                        ? moment(tramo.desde, dateFormats, true)
                                            .add(1, "days")
                                            .toDate()
                                        : new Date()
                                    }
                                    maxDate={moment(
                                        tramo.hasta,
                                        dateFormats,
                                        true
                                    ).toDate()}
                                    dateFormat="dd/mm/yy"
                                    disabled={true}
                                    />
                                </div>
                                <div className="field col-12 md:col-4">
                                    <label htmlFor={`hasta_${index}`}>Hasta</label>
                                    <Calendar
                                    id={`hasta_${index}`}
                                    showIcon
                                    value={moment(
                                        tramo.hasta,
                                        dateFormats,
                                        true
                                    ).toDate()}
                                    onChange={(e) => {
                                        selectFechaTramo(
                                        index,
                                        moment(e.value).toDate()
                                        );
                                    }}
                                    minDate={
                                        moment(
                                        tramo.desde,
                                        dateFormats,
                                        true
                                        ).isValid()
                                        ? moment(tramo.desde, dateFormats, true)
                                            .add(1, "days")
                                            .toDate()
                                        : new Date()
                                    }
                                    maxDate={moment(
                                        tramo.hasta,
                                        dateFormats,
                                        true
                                    ).toDate()}
                                    dateFormat="dd/mm/yy"
                                    disabled={index !== tramoCounter}
                                    />
                                </div>
                                </div>
                            ))}
                            <div className="field col-12 md:col-12">
                                <Button
                                icon="pi pi-check"
                                label={`Confirmar`}
                                className="p-button-rounded p-button-success p-button  mb-2 mt-2"
                                onClick={() =>
                                    handleTramoConfirmationServicio(nombreCuadro)
                                }
                                disabled={loading}
                                />
                            </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    </Dialog>
                </>
                )}
            />
            )}
        </DataTable>
        {/* FOOTER */}
        <div
            className="grid ml-2 mr-2 mb-4 mt-4"
            style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            }}
        >
            <div className="pink-color">
            <strong>Servicios Promedio Mensual:</strong>{" "}
            {subtotalServicios.toLocaleString("en-US").replace(".", ",")} UF
            </div>
        </div>
        </>
    );
};

export default ServiciosDataTable;